import { SelectDataType } from "@sso/components/Form";

import { LicenceType } from "./licence";
import { ApiPricingRules } from "./pricing";
import { PricingRule, PricingRuleCreateRequest } from "./pricingRule";

export enum SoftwareLicenceKeys {
  SOFTWARE_LICENCE_ID = "softwareLicenceId",
  NAME = "name",
  SOFTWARE = "software",
  CONCURRENT_USERS = "concurrentUsers",
  FEATURE_HTML = "featureHtml",
}

export interface SoftwareLicenceSoftware {
  id: string;
  name: string;
}

export enum SoftwareLicenceSummaryKeys {
  NAME = "name",
  LICENCE_TYPE = "licenceType",
  PAYMENT_TYPE = "paymentType",
  NUMBER_OF_LICENCED_USERS = "numberOfLicencedUsers",
  EXPIRY_UNIT = "expiryTimeUnit",
  EXPIRY_VALUE = "expiryTimeValue",
  EXPIRY_STRING = "expiryString",
  PRICING_RULES = "pricingRules",
}

export enum PaymentType {
  OneOffPayment = "OneOffPayment",
  RecurringPayment = "RecurringPayment",
  PaymentOnAccount = "PaymentOnAccount",
  Free = "Free",
}

export interface SoftwareLicence {
  [SoftwareLicenceKeys.SOFTWARE_LICENCE_ID]: string;
  [SoftwareLicenceKeys.NAME]: string;
  [SoftwareLicenceKeys.SOFTWARE]: SoftwareLicenceSoftware;
  [SoftwareLicenceKeys.FEATURE_HTML]: string;
}

export interface SoftwareLicenceSummary extends SoftwareLicence {
  [SoftwareLicenceSummaryKeys.LICENCE_TYPE]: LicenceType;
  [SoftwareLicenceSummaryKeys.PAYMENT_TYPE]: PaymentType;
  [SoftwareLicenceSummaryKeys.EXPIRY_UNIT]: TimeUnit;
  [SoftwareLicenceSummaryKeys.EXPIRY_VALUE]: number;
  [SoftwareLicenceSummaryKeys.NUMBER_OF_LICENCED_USERS]: string;
  [SoftwareLicenceKeys.CONCURRENT_USERS]: number;
  [SoftwareLicenceSummaryKeys.EXPIRY_STRING]: string;
  [SoftwareLicenceSummaryKeys.PRICING_RULES]?: PricingRule[];
}

export interface SoftwareLicenceCreateRequest {
  name: string;
  licenceType: LicenceType;
  paymentType: PaymentType;
  expiryTimeValue?: number;
  expiryTimeUnit?: TimeUnit;
  softwareId: string;
  defaultConcurrentUsers?: number;
  pricingRules?: PricingRuleCreateRequest[];
  featureHtml?: string;
}

export interface SoftwareLicenceUpdateRequest {
  softwareLicenceId?: string;
  featureHtml?: string;
}

export const paymentTypeOption: SelectDataType[] = [
  { key: PaymentType.OneOffPayment, value: PaymentType.OneOffPayment, label: "One off Payment" },
  { key: PaymentType.RecurringPayment, value: PaymentType.RecurringPayment, label: "Recurring Payment" },
  { key: PaymentType.PaymentOnAccount, value: PaymentType.PaymentOnAccount, label: "Payment On Account" },
  { key: PaymentType.Free, value: PaymentType.Free, label: "Free" },
];

export interface SoftwareLicenceFormValues {
  [SoftwareLicenceSummaryKeys.NAME]?: string;
  [SoftwareLicenceSummaryKeys.LICENCE_TYPE]?: LicenceType;
  [SoftwareLicenceSummaryKeys.PAYMENT_TYPE]?: PaymentType;
  expiryTimeValue?: number;
  expiryTimeUnit?: TimeUnit;
  defaultConcurrentUsers?: number;
  pricingRules?: PricingRuleCreateRequest[];
  apiPricingRules?: ApiPricingRules[];
  featureHtml?: string;
}

export enum TimeUnit {
  Day = "DAY",
  Month = "MONTH",
  Year = "YEAR",
}

export const timeUnitOption: SelectDataType[] = [
  { key: TimeUnit.Day, value: TimeUnit.Day, label: "Days" },
  { key: TimeUnit.Month, value: TimeUnit.Month, label: "Months" },
  { key: TimeUnit.Year, value: TimeUnit.Year, label: "Years" },
];
